import React from 'react';
import { AGridColDef } from '../../../views/pages/manage/common/data-grid/ADataGridColDef';
import ADataGrid from '../../../views/pages/manage/common/data-grid/ADataGrid';
import NoRowOverlay from '../../../views/pages/manage/masters/holidayMaster/NoRowOverlay';
import {gridStyles } from '../../../views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant';
import EnhanceDataGrid from '../../../views/pages/manage/common/data-grid/EnhanceDataGrid';
import DownloadSubmissionStatusExcel from './DownloadSubmissionStatusExcel';
import { ReactComponent as DownloadIcon } from "assets/img/svg/downloadIcon.svg";
import { downLoadFile } from '../../../views/pages/manage/masters/studentFinancials/paymentCollection/bulkCollection/utils';
import CustomChip from '../../../views/pages/manage/common/customChip/CustomChip';
import { bulkTransferUploadStatusInfoMap, bulkTransferTypes, bulkTransferPolicyStyleMap } from './constants';
import { LastUpdatedDetails } from 'views/pages/manage/employeeManagement/userProfile/helper';
import { Tooltip } from '@mui/material';



const BulkTransferRequestsList = ({
    rows = [],
    paginationInfo,
    getBulkTransferRequestsList
  }) => {

  const getTransferTypeLabel = (transferTypeValue) => {
    const transferType = bulkTransferTypes.find(type => type.label?.toLowerCase().includes(transferTypeValue?.toLowerCase()));
    return transferType?.label || transferTypeValue;
  };

  const columns = [

    new AGridColDef("processId", "ProcessId")
      .setMinWidth(90)
      .setFlex(0.5)
      .setValueGetter((params) => params?.value),

    new AGridColDef("uploadedBy", "Uploaded By")
      .setMinWidth(110)
      .setFlex(0.5)
      .setValueGetter((params) => params?.value),

    new AGridColDef("createdOn", "Uploaded On")
      .setMinWidth(120)
      .setFlex(0.8)
      .renderCellComponent((params) => LastUpdatedDetails(params?.value)),

    new AGridColDef("transferType", "Transfer Type")
      .setMinWidth(120)
      .setFlex(0.8)
      .renderCellComponent((params) =>params?.value ? <Tooltip title={getTransferTypeLabel(params?.value)}><div className="ellipsis-text-container">{getTransferTypeLabel(params?.value)}</div></Tooltip> : <div>-</div>),

    new AGridColDef("transferPolicy", "Transfer Policy")
      .setMinWidth(120)
      .setFlex(0.8)
      .renderCellComponent((params) => params?.value ? <CustomChip {...bulkTransferPolicyStyleMap[params?.value?.toUpperCase()]} style={{ textAlign : 'center'}}/> : <div>-</div>),

    new AGridColDef("remark", "Remark")
      .setMinWidth(110)
      .setFlex(0.5)
      .renderCellComponent((params) =>params?.value ? <Tooltip title={params?.value}><div className="ellipsis-text-container">{params?.value}</div></Tooltip> : <div>-</div>),

    new AGridColDef("status", "Status")
      .setMinWidth(90)
      .setFlex(0.6)
      .editable(true)
      .renderCellComponent((params) => (
         <CustomChip {...bulkTransferUploadStatusInfoMap[params?.value]} style={{textAlign : 'center'}}/>
      )),

    new AGridColDef("supportingDocKey", "Supporting Doc")
      .setMinWidth(80)
      .setFlex(0.5)
      .editable(true)
      .columnAlign('center')
      .renderCellComponent((params) => (
          <DownloadIcon className='cursor' onClick={() => downLoadFile(params?.value)}/>
      )),

    new AGridColDef("action", "Action")
      .setMinWidth(80)
      .setFlex(0.5)
      .editable(true)
      .columnAlign('center')
      .renderCellComponent((params) => {
        const {processId, status , fileName} = params?.row;
        return(
          status=="SUCCESS" ?
         <DownloadSubmissionStatusExcel
         processId={processId}
         status={status}
         fileName={fileName}
        transferType={params?.row?.transferType}
         />:
          <div>-</div>
      )}),
   
  ];
  const { totalRecords, currPageNo, currPageSize } = paginationInfo;

  return (
      <EnhanceDataGrid
        removeWrapperContainer
        paginationModel={{ page: currPageNo, pageSize: currPageSize }}
        rows={rows || []}
        columns={columns}
        rowId={(row) => row.processId}
        rowHeight={50}
        loading={false}
        rowCount={totalRecords}
        nextButtonHandler={(pageNo, pageSize) => getBulkTransferRequestsList({ offset : pageNo, pageSize })}
        currentPage={currPageNo}
        sx={gridStyles}
        autoHeight
        pinLastColumn
      />
      )

};

export default BulkTransferRequestsList;
